import { render, staticRenderFns } from "./UserAssetList.vue?vue&type=template&id=9f3b9274&"
import script from "./UserAssetList.vue?vue&type=script&lang=js&"
export * from "./UserAssetList.vue?vue&type=script&lang=js&"
import style0 from "./UserAssetList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports